import React, { useLayoutEffect, useState } from 'react'
import styled from 'styled-components'
import { useNavigate, generatePath, useParams } from 'react-router-dom'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import CardHeader from 'react-bootstrap/CardHeader'
import Button from 'react-bootstrap/Button'
import { useSelector, useDispatch } from 'react-redux'
import { APP_ROUTES } from 'app/components/AppRouter/routes'
import { RootState } from 'app/state/types'
import { setApk, setIsLoading } from 'app/state/appSlice'
import { getAppApk, getApp } from 'app/services/client'
import { isTokenExpired, makeDownloadApkLink } from 'app/utils/hooks'
import { handleServerAPIError } from 'app/services/utils'

const StyledLink = styled.a`
    text-decoration: none;
    color: black;
`

const APKDetailsView = () => {
    const [appName, setAppName] = useState<string>()
    const { appid, id } = useParams()
    const { apk } = useSelector((state: RootState) => state.appSlice)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useLayoutEffect(() => {
        if (appid && id) {
            dispatch(setIsLoading(true))
            getApp(appid)
                .then(res => {
                    const app = res.data
                    setAppName(app.appName)
                })
                .catch(e => handleServerAPIError(e, dispatch, navigate))
            getAppApk(appid, id)
                .then(res => {
                    dispatch(setApk(res.data))
                })
                .catch(e => handleServerAPIError(e, dispatch, navigate))
                .finally(() => dispatch(setIsLoading(false)))
        }
    }, [])

    return (
        <Container>
            <Col xs="12" className="mt-2 mb-2">
                <Row>
                    <StyledLink
                        href={generatePath(APP_ROUTES.APP_DETAILS, {
                            id: appid,
                        })}>
                        <p className="display-6">{appName}</p>
                    </StyledLink>
                </Row>
                <hr />
                <Row>
                    <Col>
                        <p className="display-6">{`Version: ${
                            apk.versionName
                        } ${
                            apk.versionCode ? '(' + apk.versionCode + ')' : ''
                        }`}</p>
                    </Col>
                    <Col className="align-self-center">
                        <Button
                            disabled={!apk.apkUploaded}
                            variant="outline-success"
                            size="sm"
                            onClick={() => {
                                if (appid && id) {
                                    window.open(
                                        makeDownloadApkLink(appid, id),
                                        '_blank',
                                    )
                                }
                            }}>
                            Download
                        </Button>
                        {!isTokenExpired() && (
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                style={{ marginLeft: '10px' }}
                                onClick={() => {
                                    navigate(
                                        generatePath(APP_ROUTES.EDIT_APK, {
                                            appid: appid,
                                            id: id,
                                        }),
                                    )
                                }}>
                                Edit APK
                            </Button>
                        )}
                    </Col>
                </Row>
                <hr />
                <Card>
                    <CardHeader>What's New?</CardHeader>
                    <Card.Body>{apk.apkWhatsNew}</Card.Body>
                </Card>
            </Col>
        </Container>
    )
}

export default APKDetailsView
